<template>
  <div class="page-container">
    <!-- Header -->
    <header class="header" :class="{ 'scrolled': !isHeaderTransparent }">
      <div class="logo" @click="goHome()">
        <img style="width: 130px;object-fit: cover;cursor: pointer;" src="./assets/img/yztx.png" alt="屿智" />
      </div>

      <div class="nav-buttons">
        <template v-if="isLoggedIn">
          <span class="user-info">欢迎，{{ userInfo.nickname || userInfo.phone || '用户' }}</span>
          <button @click="logout" class="btn btn-outline">退出登录</button>
        </template>
        <template v-else>
          <router-link to="/store/entry/loginPwd" tag="button" class="btn btn-primary">注册/试用</router-link>
        </template>
      </div>
    </header>

    <section class="hero-section">
      <div class="hero-text">
        <h1>不再盲目求职</h1>
        <h1>让顶尖行业专家为你锁定理想Offer</h1>
        <p>
          1V1专属定制求职陪跑服务，从简历优化、面试演练到薪酬谈判，我们提供全程保障，<br>祝你斩获心仪工作
        </p>
        <a href="#" class="btn" @click="showPhoneDialog">点击报名免费咨询<br>
          <span style="font-size: 12px;margin-left:7px">定制你的求职方案</span>
        </a>
      </div>
      <div class="hero-image">
        <img src="./assets/img/character.png" alt="Character" class="character-image">
      </div>
    </section>
    <!-- Feature Section -->
    <section class="feature-section">
      <div class="feature-container">
        <div class="feature-item">
          <h3>名企导师</h3>
          <p>前沿行业洞见</p>
        </div>
        <div class="feature-item">
          <h3>1V1定制</h3>
          <p>拒绝同质化辅导</p>
        </div>
        <div class="feature-item">
          <h3>Offer保障</h3>
          <p>选择更安心</p>
        </div>
        <div class="feature-item">
          <h3>全程陪跑</h3>
          <p>从小白到Offer收割机</p>
        </div>
      </div>
    </section>

    <!-- Problem Section -->
    <section class="problem-section">
      <div class="problem-container">
        <h2>你是否正在面临这些求职困境？</h2>
        <div class="problem-cards">
          <div class="problem-card">
            <img v-lazyload="problemImages[0]" alt="简历石沉大海" class="problem-image" />
            <p>简历石沉大海</p>
          </div>
          <div class="problem-card">
            <img v-lazyload="problemImages[1]" alt="面试屡战屡败" class="problem-image" />
            <p>面试屡战屡败</p>
          </div>
          <div class="problem-card">
            <img v-lazyload="problemImages[2]" alt="缺乏职业规划" class="problem-image" />
            <p>缺乏职业规划</p>
          </div>
          <div class="problem-card">
            <img v-lazyload="problemImages[3]" alt="薪酬谈判没底气" class="problem-image" />
            <p>薪酬谈判没底气</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Solution Section -->
    <section class="solution-section">
      <div class="solution-container">
        <h2>我们的解决方案：4步搞定理想OFFER</h2>
        <div class="solution-cards">
          <div class="solution-card">
            <div class="step-number">1</div>
            <h3>深度评估与诊断</h3>
            <img v-lazyload="solutionImages[0]" alt="深度评估与诊断" class="solution-image" />
            <p>
              金牌顾问与你进行一对一沟通，全面评估你的背景、能力与求职目标，精准定位问题所在。
            </p>
          </div>
          <div class="solution-card">
            <div class="step-number">2</div>
            <h3>定制化求职策略</h3>
            <img v-lazyload="solutionImages[1]" alt="定制化求职策略" class="solution-image" />
            <p>
              匹配最适合你的行业专家，为你量身定制针对性学习方案，手把手带你靠近理想岗位。
            </p>
          </div>
          <div class="solution-card">
            <div class="step-number">3</div>
            <h3>全程执行与辅导</h3>
            <img v-lazyload="solutionImages[2]" alt="全程执行与辅导" class="solution-image" />
            <p>
              覆盖笔试、群面、单面等所有环节的无限次模拟面试，导师手把手带你复盘，直到你充满自信。
            </p>
          </div>
          <div class="solution-card">
            <div class="step-number">4</div>
            <h3>斩获Offer与谈判</h3>
            <img v-lazyload="solutionImages[3]" alt="斩获Offer与谈判" class="solution-image" />
            <p>
              获得Offer后，专家将指导你进行薪酬谈判，争取最优待遇，并提供入职适应期支持。
            </p>
          </div>
        </div>
      </div>
    </section>
    <!-- Expert Team Section -->
    <section class="expert-team-section">
      <div class="expert-container">
        <h2>金牌专家团队——你的专属求职智囊</h2>
        <div class="expert-cards">
          <div class="expert-card">
            <div class="expert-content">
              <div class="expert-info">
                <h3>Brady</h3>
                <p class="expert-title">曾任阿里巴巴·资深产品经理</p>
                <p class="expert-field">擅长领域：互联网产品、求职规划、高阶面试技巧</p>
                <p class="expert-desc">"已成功帮助100+学员进入TMD、BAT等一线大厂。"</p>
              </div>
              <img v-lazyload="experts[0].imageUrl" alt="Brady" class="expert-image" />
            </div>
          </div>
          <div class="expert-card">
            <div class="expert-content">
              <div class="expert-info">
                <h3>Cynthia</h3>
                <p class="expert-title">曾任宝洁·市场部高级品牌经理</p>
                <p class="expert-field">擅长领域：快速消费品(FMCG)行业、市场营销</p>
                <p class="expert-desc">"深谙外企招聘之道,已指导众多学员斩获宝洁、联合利华等顶尖快消Offer。"</p>
              </div>
              <img v-lazyload="experts[1].imageUrl" alt="Cynthia" class="expert-image" />
            </div>
          </div>
          <div class="expert-card">
            <div class="expert-content">
              <div class="expert-info">
                <h3>Alex Chen</h3>
                <p class="expert-title">曾任摩根士丹利·投资银行部分析师</p>
                <p class="expert-field">擅长领域：金融行业、投行/券商申请、估值建模</p>
                <p class="expert-desc">"精通金融圈求职全流程,助力数十位学员成功闯入顶级投行与咨询公司。"</p>
              </div>
              <img v-lazyload="experts[2].imageUrl" alt="Alex Chen" class="expert-image" />
            </div>
          </div>
          <div class="expert-card">
            <div class="expert-content">
              <div class="expert-info">
                <h3>Leo</h3>
                <p class="expert-title">曾任字节跳动·资深算法工程师</p>
                <p class="expert-field">擅长领域：技术岗求职、算法与数据结构、系统设计</p>
                <p class="expert-desc">"作为前技术面试官,我能帮你精准攻克技术面试难点,已助学员拿下谷歌、字节等S-Offer。"</p>
              </div>
              <img v-lazyload="experts[3].imageUrl" alt="Leo" class="expert-image" />
            </div>
          </div>
        </div>
        <div class="more-experts">
          <button class="btn">更多专家</button>
        </div>
      </div>
    </section>

    <!-- Partner Companies Section -->
    <section class="partner-companies-section">
      <div class="partner-container">
        <h2>部分学员入职企业</h2>
        <div class="partner-logos">
          <div class="partner-logo">
            <img v-lazyload="partnerLogos[0]" alt="字节跳动" />
          </div>
          <div class="partner-logo">
            <img v-lazyload="partnerLogos[1]" alt="阿里巴巴" />
          </div>
          <div class="partner-logo">
            <img v-lazyload="partnerLogos[2]" alt="腾讯" />
          </div>
          <div class="partner-logo">
            <img v-lazyload="partnerLogos[3]" alt="华为" />
          </div>
          <div class="partner-logo">
            <img v-lazyload="partnerLogos[4]" alt="百度" />
          </div>
          <div class="partner-logo">
            <img v-lazyload="partnerLogos[5]" alt="京东" />
          </div>
          <!--  <div class="partner-logo">
            <img v-lazyload="partnerLogos[6]" alt="美团" />
          </div> -->
          <div class="partner-logo">
            <img v-lazyload="partnerLogos[7]" alt="大疆" />
          </div>
          <div class="partner-logo">
            <img v-lazyload="partnerLogos[8]" alt="OPPO" />
          </div>
        </div>
      </div>
    </section>
      <!-- FAQ Section -->
    <section class="faq-section">
      <div class="faq-container">
        <h2>常见问题</h2>
        <div class="faq-item" v-for="(question, index) in faqQuestions" :key="index">
          <div class="faq-question" @mouseenter="showAnswer = index" @mouseleave="showAnswer = null">
            {{ showAnswer === index ? faqAnswers[index] : question }}
          </div>
        </div>
      </div>
    </section>

    <footer class="company-info">
      <div class="footlogo">
        <img src="./assets/img/_20250528182615-20.png" alt="屿智同行">
      </div>
      <div class="info">
        <p>深圳市屿智同行科技有限公司</p>
        <p>地址：深圳市南山区丽水路2279号清华大学深圳国际研究生院</p>
        <p>邮箱：yztx_zyh@163.com</p>
      </div>
    </footer>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" center>
      <span>该功能近期上线，敬请期待~</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    
    <!-- 电话号码收集弹窗 -->
    <div v-if="phoneDialogVisible" class="phone-dialog-overlay" @click="phoneDialogVisible = false">
      <div class="phone-dialog" @click.stop>
        <div class="phone-dialog-content">
          <!-- 关闭按钮 -->
          <span class="phone-close-btn" @click="phoneDialogVisible = false">×</span>
          
          <!-- 左侧插图 -->
          <div class="phone-illustration">
            <img src="./assets/img/phone.png" alt="免费咨询报名" class="phone-image">
          </div>
          
          <!-- 右侧内容 -->
          <div class="phone-content">
            <!-- 主标题 -->
            <div class="phone-title">
              <h2 class="title-main">免费咨询报名</h2>
            </div>
            
            <!-- 说明文字 -->
            <div class="phone-description">
              <p class="description-text">
                请留下您的手机号码,我们的专业顾问将为您提供1V1定制求职方案,助力拿下offer!
              </p>
            </div>
            
            <!-- 手机号输入框 -->
            <div class="phone-input-section">
              <div class="phone-form">
                <div class="phone-form-item">
                  <input 
                    v-model="phoneForm.phone" 
                    type="tel"
                    placeholder="请输入手机号码"
                    :class="['phone-input', { 'error': phoneError }]"
                    @blur="validatePhone"
                    @input="clearPhoneError">
                  <span class="required-asterisk">*</span>
                  <div v-if="phoneError" class="phone-error">{{ phoneError }}</div>
                </div>
              </div>
            </div>
            
            <!-- 进度指示器 -->
            <div class="phone-progress-indicator">
              <div class="progress-step active">
                <div class="step-circle"></div>
                <span class="step-label">留下手机号</span>
              </div>
              <div class="progress-step">
                <div class="step-circle"></div>
                <span class="step-label">定制方案</span>
              </div>
              <div class="progress-step">
                <div class="step-circle"></div>
                <span class="step-label">拿到offer</span>
              </div>
            </div>
            
            <!-- 按钮区域 -->
            <div class="phone-buttons">
              <button class="phone-close-button" @click="phoneDialogVisible = false">
                关闭
              </button>
              <button :class="['phone-submit-button', { 'valid': isPhoneValid }]" @click="submitPhoneForm" :disabled="!isPhoneValid">
                提交
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginInfo from '@/mixins/LoginInfo'

export default {
  mixins: [LoginInfo],
  data() {
    return {
      activeIndex: 0,
      isHeaderTransparent: true,
      dialogVisible: false,
      phoneDialogVisible: false,
      phoneForm: {
        phone: ''
      },
      phoneError: '',
      isPhoneValid: false,
      faqQuestions: [
        'Q1：如果对匹配的导师不满意怎么办？',
        'Q2：具体退款条件是什么？',
        'Q3：整个服务周期大概是多久？'
      ],
      faqAnswers: [
        'A1：我们在服务初期根据您的需求免费更换导师，直到匹配到最适合您的那一位。',
        'A2：如果未能在协议规定时间内帮助您获得约定范围内的有效Offer，我们将依据合同条款进行退款，24小时内到账。',
        'A3：服务周期因人而异，通常为1-3个月，具体依照评估后签署的合同规定。'
      ],
      showAnswer: null,
      activeAnswer: null,
      problemImages: [
        require('./assets/img/problem1.png'),
        require('./assets/img/problem2.png'),
        require('./assets/img/problem3.png'),
        require('./assets/img/problem4.png')
      ],
      solutionImages: [
        require('./assets/img/solution1.png'),
        require('./assets/img/solution2.png'),
        require('./assets/img/solution3.png'),
        require('./assets/img/solution4.png')
      ],
      experts: [
        { name: 'Brady', title: '曾任 阿里巴巴·资深产品经理', field: '互联网产品、求职规划、高效面试技巧', desc: '"已成功帮助100+学员进入TMD、BAT等一线大厂。"', imageUrl: require('./assets/img/expert1.png') },
        { name: 'Cynthia', title: '曾任 宝洁·市场部高级品牌经理', field: '快速消费品(FMCG)行业，市场营销', desc: '"深谙外企招聘之道，已指导众多学员斩获宝洁、联合利华等顶尖快消Offer。"', imageUrl: require('./assets/img/expert2.png') },
        { name: 'Alex Chen', title: '曾任 摩根士丹利·投资银行部分析师', field: '金融行业，投行/券商申请，估值建模', desc: '"精通金融圈求职全流程，助力数十名学员成功闯入顶级投行与咨询公司。"', imageUrl: require('./assets/img/expert3.png') },
        { name: 'Leo', title: '曾任 字节跳动·资深算法工程师', field: '技术岗求职，算法与数据结构、系统设计', desc: '"作为前技术面试官，我能帮你精准攻克技术面试难点，已助学员拿下谷歌、字节等S-Offer。"', imageUrl: require('./assets/img/expert4.png') }
      ],
      partnerLogos: [
        require('./assets/img/partner1.png'),
        require('./assets/img/partner2.png'),
        require('./assets/img/partner3.png'),
        require('./assets/img/partner4.png'),
        require('./assets/img/partner5.png'),
        require('./assets/img/partner6.png'),
        require('./assets/img/partner7.png'),
        require('./assets/img/partner8.png'),
        require('./assets/img/partner9.png')
      ],

    };
  },
  computed: {
    // 判断是否已登录
    isLoggedIn() {
      return this.isLogin && this.userInfo && this.userInfo.id;
    }
  },
  methods: {
    goHome() {
      this.$router.push('/');
    },
    logout() {
      this.$store.dispatch('user/logout').then(() => {
        this.$message.success('已成功退出登录');
        this.$router.push('/store/entry');
      }).catch(error => {
        console.error('退出登录失败:', error);
        this.$message.error('退出登录失败，请重试');
      });
    },
    toggleAnswer(index) {
      this.activeAnswer = this.activeAnswer === index ? null : index;
    },
    changeSlide(index) {
      this.activeIndex = index;
      this.$refs.carousel.setActiveItem(index);
    },
    handleScroll() {
      const scrollTop = window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      this.isHeaderTransparent = scrollTop < 50;
    },
    showPhoneDialog() {
      this.phoneDialogVisible = true;
    },
    validatePhone() {
      const phone = this.phoneForm.phone.trim();
      
      if (!phone) {
        this.phoneError = '请输入手机号';
        this.isPhoneValid = false;
        return false;
      }
      
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.phoneError = '请输入正确的手机号格式';
        this.isPhoneValid = false;
        return false;
      }
      
      this.phoneError = '';
      this.isPhoneValid = true;
      return true;
    },
    clearPhoneError() {
      this.phoneError = '';
      // 实时验证手机号格式
      const phone = this.phoneForm.phone.trim();
      if (phone && /^1[3-9]\d{9}$/.test(phone)) {
        this.isPhoneValid = true;
      } else {
        this.isPhoneValid = false;
      }
    },
    async submitPhoneForm() {
      if (this.validatePhone()) {
        try {
          // 调用addPhone接口
          const { addPhone } = await import('@/api/recommend');
          await addPhone({ mobile: this.phoneForm.phone });
          
          // 显示成功消息
          alert('提交成功！我们的专业顾问将在24小时内联系您');
          
          // 关闭弹窗并重置表单
          this.phoneDialogVisible = false;
          this.resetPhoneForm();
        } catch (error) {
          console.error('提交失败:', error);
          alert('提交失败，请稍后重试');
        }
      } else {
        alert('请检查输入信息');
        return false;
      }
    },
    resetPhoneForm() {
      this.phoneForm = {
        phone: ''
      };
      this.phoneError = '';
      this.isPhoneValid = false;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  directives: {
    // 定义懒加载指令
    lazyload: {
      inserted(el, binding) {
        // 创建占位符
        const defaultPlaceholder = 'data:image/gif;base64,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';
        el.src = defaultPlaceholder;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.src = binding.value;
              observer.unobserve(el);
            }
          });
        }, { threshold: 0.01 });

        observer.observe(el);
      },
      componentUpdated(el, binding) {
        // 在组件更新时重新观察元素
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.src = binding.value;
              observer.unobserve(el);
            }
          });
        }, { threshold: 0.01 });

        observer.observe(el);
      }
    }
  }
};
</script>
<style scoped lang="less">
.btn {
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.btn-primary {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  border-radius: 24px;
  color: white;
  border: none;
  width: 120px;
  height: 44px;
}
.text1 {
  color: #656587;
}

.text2 {
  background: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.page-container {
  /*  background: linear-gradient(to bottom, #ffffff, #d9e2ff); */
  background: #ffffff url("./assets/img/bg.png") no-repeat center / cover;
  width: 100%;
  height: 100%;
  font-family: sans-serif;
  overflow-x: hidden;
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 15px 20px;
  background: linear-gradient(to right, #ffffff, transparent);
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

}

.header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), #FEFEFE);
  z-index: -1;
}

.header.scrolled {

  background-color: transparent;

  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.logo span {
  font-size: 24px;
  font-weight: bold;
      font-weight: bold;
      background: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}



.nav-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
}

.user-info {
  color: #666;
  font-size: 14px;
  margin-right: 10px;
}

.btn-outline {
  background: transparent;
  border: 1px solid #ddd;
  color: #666;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.btn-outline:hover {
  background: #f5f5f5;
  border-color: #999;
}

.hero-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;

  min-height: 50vh;

  .hero-text {
    max-width: 50%;
  }

  .hero-image {
    width: 40%;

    .character-image {
      width: 100%;
    }
  }

  h1 {
    font-size: 36px;
    margin-bottom: 16px;
    font-weight: bold;
      background: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  }



  p {
    font-size: 16px;
    color: #666;
    line-height: 1.8;
    margin-bottom: 30px;
  }

  .btn {
    display: inline-block;
    padding: 12px 32px;
    background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%),
                linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
    color: white;
    border-radius: 30px;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.3s ease;
  }

  .btn:hover {
    box-shadow: 0 4px 12px rgba(106, 85, 255, 0.3);
    transform: translateY(-2px);
  }

  @media (max-width: 768px) {
    .hero-section {
      flex-direction: column;
      text-align: center;
      padding: 40px 20px;
    }

    .hero-text {
      margin-bottom: 40px;
    }

    h1 {
      font-size: 28px;
    }

    h2 {
      font-size: 20px;
    }

    p {
      margin-bottom: 20px;
    }
  }
}


.feature-section {
  padding: 40px 20px;

  .feature-container {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    margin: 0 auto;

    .feature-item {
      flex: 1;
      text-align: center;
      padding: 20px;

      &:not(:last-child) {
        border-right: 1px solid #e0e0e0;
      }

      h3 {
        font-size: 24px;
            font-weight: bold;
      background: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
        margin-bottom: 10px;
      }

      p {
        font-size: 14px;
        color: #666;
      }
    }
  }

  @media (max-width: 768px) {
    .feature-container {
      flex-direction: column;

      .feature-item {
        border-right: none;
        border-bottom: 1px solid #e0e0e0;
        padding: 20px 0;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}

.problem-section {
  padding: 40px 20px;

  .problem-container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;

    h2 {
      font-size: 32px;
          font-weight: bold;
      background: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
      margin-bottom: 50px;
      font-weight: normal;
    }

    .problem-cards {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 20px;

      .problem-card {
        flex: 1;
        min-width: 220px;
        max-width: 250px;
        text-align: center;
        padding: 20px;

        .problem-image {
          width: 200px;
          height: 200px;
          object-fit: cover;
          border-radius: 50%;
          margin-bottom: 15px;
        }

        p {
          font-size: 16px;
          color: #666;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .problem-cards {
      flex-direction: column;
      align-items: center;

      .problem-card {
        margin-bottom: 30px;
      }
    }
  }
}

.solution-section {
  padding: 40px 20px;

  .solution-container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;

    h2 {
      font-size: 32px;
          font-weight: bold;
      background: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
      margin-bottom: 50px;
      font-weight: normal;
    }

    .solution-cards {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      gap: 20px;

      .solution-card {
        flex: 1;
        min-width: 220px;
        max-width: 250px;
        background-color: white;
        border-radius: 10px;
        padding: 20px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        position: relative;
        transition: transform 0.3s ease;

        &:hover {
          transform: translateY(-5px);
        }

        .step-number {
          position: absolute;
          top: -20px;
          left: 20px;
          font-size: 48px;
          color: #4a9eff;
          font-weight: bold;
          line-height: 1;
        }

        h3 {
          font-size: 18px;
              font-weight: bold;
      background: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
          margin-bottom: 15px;
        }

        .solution-image {
          width: 100%;
          height: 150px;
          object-fit: cover;
          margin-bottom: 15px;
          border-radius: 5px;
        }

        p {
          font-size: 14px;
          color: #666;
          text-align: left;
          margin-bottom: 10px;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .solution-cards {
      flex-direction: column;
      align-items: center;

      .solution-card {
        margin-bottom: 30px;
        max-width: 100%;
      }
    }
  }
}

.expert-team-section {
  padding: 40px 20px;

  .expert-container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;

    h2 {
      font-size: 32px;
          font-weight: bold;
      background: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
      margin-bottom: 40px;
      font-weight: normal;
    }

    .expert-cards {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 32px;
      margin-bottom: 30px;
      padding: 0 40px;

      .expert-card {
        width: calc(50% - 16px);
        min-height: 180px;
        max-width: 400px;
        background-color: rgba(248, 248, 248, 0.4);
        border-radius: 12px;
        padding: 24px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        border: 1px solid #E8E8E8;
        position: relative;
        overflow: hidden;



        .expert-content {
          display: flex;
          align-items: flex-start;
          gap: 20px;
          height: 100%;

          .expert-info {
            flex: 1;

            h3 {
              font-size: 18px;
              font-weight: 600;
              background: linear-gradient(90deg, #7EB4EB -221.38%, #B16EF9 4128.85%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              margin: 0 0 8px 0;
              line-height: 1.2;
              text-align: left;
            }

            .expert-title {
              font-size: 14px;
              color: #666666;
              margin: 0 0 12px 0;
              line-height: 1.4;
              text-align: left;
            }

            .expert-field {
              font-size: 14px;
              color: #666666;
              margin: 0 0 12px 0;
              line-height: 1.4;
              text-align: left;
            }

            .expert-desc {
              font-size: 14px;
              color: #666666;
              margin: 0;
              line-height: 1.4;
              font-style: italic;
              text-align: left;
            }
          }

          .expert-image {
            width: 120px;
            height: 120px;
            border-radius: 50%;
            object-fit: cover;
            background: linear-gradient(135deg, #E0D9F7 0%, #F0ECFB 100%);
            border: 2px solid #E0D9F7;
            flex-shrink: 0;
          }
        }
      }
    }

    .more-experts {
      text-align: center;

      .btn {
        display: inline-block;
        padding: 12px 32px;
        background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%),
                    linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
        color: white;
        border-radius: 30px;
        font-size: 16px;
        font-weight: 500;
        text-decoration: none;
        transition: all 0.3s ease;

        &:hover {
          box-shadow: 0 4px 12px rgba(106, 85, 255, 0.3);
          transform: translateY(-2px);
        }
      }
    }
  }

  @media (max-width: 768px) {
    .expert-cards {
      gap: 20px;
      padding: 0 20px;
      
      .expert-card {
        width: 100%;
        min-height: 160px;
        padding: 20px;
        
        .expert-content {
          gap: 12px;
          
          .expert-image {
            width: 90px;
            height: 90px;
          }
          
          .expert-info {
            h3 {
              font-size: 16px;
            }
            
            .expert-title,
            .expert-field,
            .expert-desc {
              font-size: 13px;
            }
          }
        }
      }
    }
  }
}

.partner-companies-section {
  padding: 40px 20px;

  .partner-container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;

    h2 {
      font-size: 32px;
          font-weight: bold;
      background: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
      margin-bottom: 40px;
      font-weight: normal;
    }

    .partner-logos {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 30px;

      .partner-logo {
        flex: 0 0 calc(25% - 30px);
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }
    }

    @media (max-width: 768px) {
      .partner-logo {
        flex: 0 0 calc(33.33% - 20px);
      }
    }

    @media (max-width: 480px) {
      .partner-logo {
        flex: 0 0 calc(50% - 15px);
      }
    }
  }
}

footer {
  background-color: #6b6b83;
  color: #fff;
  padding: 20px 0;
  font-size: 14px;
  line-height: 1.6;

  .footlogo img {
    width: 340px;
    height: 88px;
  }

  .info {
    margin-left: 50px;
    max-width: 600px;
    text-align: left;
    padding: 0 20px;
  }
}

.faq-section {
  padding: 40px 20px;

  .faq-container {
    max-width: 1200px;
    margin: 0 auto;
    text-align: center;

    h2 {
      font-size: 32px;
          font-weight: bold;
      background: var(--linear-2-paints,
      linear-gradient(90deg,
        rgba(126, 180, 235, 1) 0%,
        rgba(177, 110, 249, 1) 100%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
      margin-bottom: 40px;
      font-weight: normal;
    }

    .faq-item {
      margin-bottom: 20px;

      .faq-question {
        padding: 20px;
        background: linear-gradient(to right, #ffffff, transparent);
        border: 1px solid #e0e0e0;
        border-radius: 20px;
        text-align: center;
        cursor: pointer;
        font-size: 16px;
        color: #666;
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
        min-height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background-color: rgba(255, 255, 255, 0.9);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
      }
    }

    @media (max-width: 768px) {
      .faq-question {
        font-size: 14px;
      }
    }
  }
}

/* 电话号码收集弹窗样式 */
.phone-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.phone-dialog {
  width: 480px;
  max-width: 70vw;
  max-height: 60vh;
  overflow: hidden;
}

.phone-dialog-content {
  display: flex;
  align-items: center;
  padding: 25px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%);
  border-radius: 12px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.1);
  position: relative;
  min-height: 300px;
}

.phone-close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: white;
  color: #7EB4EB;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;
  border: 2px solid #7EB4EB;
}

.phone-close-btn:hover {
  transform: scale(1.1);
}

.phone-illustration {
  flex: 0 0 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 25px;
}

.phone-image {
  width: 140px;
  height: auto;
  border-radius: 8px;
}

.phone-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.phone-title {
  margin-bottom: 15px;
}

.title-main {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin: 0;
  font-family: 'Afacad', sans-serif;
}

.phone-description {
  margin-bottom: 18px;
}

.description-text {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  margin: 0;
  font-family: 'Afacad', sans-serif;
}

.phone-input-section {
  margin-bottom: 18px;
}

.phone-form {
  margin: 0;
}

.phone-form-item {
  margin-bottom: 0;
  position: relative;
}

.phone-input {
  width: 100%;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  height: 44px;
  line-height: 44px;
  outline: none;
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.phone-input:focus {
  border-color: #8B5CF6;
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.1);
}

.phone-input.error {
  border-color: #EF4444;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.1);
}

.required-asterisk {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #EF4444;
  font-size: 16px;
  font-weight: bold;
}

.phone-error {
  color: #EF4444;
  font-size: 12px;
  margin-top: 4px;
  font-family: 'Afacad', sans-serif;
}

.phone-progress-indicator {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  position: relative;
}

.phone-progress-indicator::before {
  content: '';
  position: absolute;
  top: 8px;
  left: 8px;
  right: 8px;
  height: 2px;
  background: linear-gradient(90deg, #8B5CF6 0%, #E5E7EB 100%);
  z-index: 1;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
  flex: 1;
}

.step-circle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #E5E7EB;
  border: 2px solid #E5E7EB;
  margin-bottom: 6px;
  transition: all 0.3s ease;
}

.progress-step.active .step-circle {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  border-color: #8B5CF6;
  box-shadow: 0 0 0 4px rgba(139, 92, 246, 0.2);
}

.step-label {
  font-size: 10px;
  color: #6B7280;
  text-align: center;
  font-family: 'Afacad', sans-serif;
  font-weight: 500;
}

.progress-step.active .step-label {
  color: #8B5CF6;
  font-weight: 600;
}

.phone-buttons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.phone-close-button {
  background: white;
  color: #8B5CF6;
  border: 1px solid #8B5CF6;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 500;
  font-family: 'Afacad', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 60px;
}

.phone-close-button:hover {
  background: rgba(139, 92, 246, 0.05);
  transform: translateY(-1px);
}

.phone-submit-button {
  background: #6B7280;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 500;
  font-family: 'Afacad', sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 60px;
}

.phone-submit-button:hover:not(:disabled) {
  background: #4B5563;
  transform: translateY(-1px);
}

.phone-submit-button:disabled {
  background: #D1D5DB;
  cursor: not-allowed;
  transform: none;
}

.phone-submit-button.valid {
  background: linear-gradient(90deg, #7EB4EB 0%, #B16EF9 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
}

.phone-submit-button.valid:hover {
  background: linear-gradient(90deg, #6BA3E8 0%, #A55EE8 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.5), rgba(132, 172, 237, 0.5));
  transform: translateY(-1px);
}

/* 表单样式优化 */
.el-form-item__label {
  color: #333;
  font-weight: 500;
}

.el-input__inner {
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  transition: border-color 0.3s ease;
  
  &:focus {
    border-color: #7eb4eb;
    box-shadow: 0 0 0 2px rgba(126, 180, 235, 0.2);
  }
}

/* 按钮样式 */
.dialog-footer {
  text-align: center;
  
  .el-button {
    border-radius: 6px;
    padding: 10px 20px;
    font-weight: 500;
    
    &.el-button--primary {
      background: linear-gradient(90deg, rgba(126, 180, 235, 1) 0%, rgba(177, 110, 249, 1) 100%);
      border: none;
      
      &:hover {
        opacity: 0.9;
        transform: translateY(-1px);
      }
    }
  }
}
</style>